import PAPI from "./apiInstance";
import { userAccessToken } from "../helpers";

export const fetchAdvancedDirectiveForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    sex,
    option2_tel_no,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `/form/advanced_directive_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}&first_name=${first_name}&last_name=${last_name}&dob=${dob}&sex=${sex}&mobile_phone=${option2_tel_no}&${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const addSingleAdvancedDirectiveForm = async (formData) => {
  formData.colorectal_cs_time_period_months = 12

  try {
    const response = await PAPI.post(`/patients/create`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchSingleAdvancedDirectiveForm = async (
  account_id,
  location_id,
  id
) => {
    
  try {
    const response = await PAPI.get(
      `/form/advanced_directive_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchHipaaConsentForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/hipaa_consent_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSingleHipaaConsentForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/hipaa_consent_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchOlderCareForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/older_care_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSingleOlderCareForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/older_care_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchPatientIntakeForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/patient_intake_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSinglePatientIntakeForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/patient_intake_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchPatientSurveyForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/patient_survey_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSinglePatientSurverForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/patient_survey_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchBulkPatientSurverForm = async (printFilter) => {
  try {
    const result = {data:{
      "results": {
        "total": 20,
        "total_survey_1_yes": 60,
        "total_survey_1_sometime": 20,
        "total_survey_1_no": 20,
        "total_survey_2_yes": 45.5,
        "total_survey_2_sometime": 20,
        "total_survey_2_no": 35.5,
        "total_survey_3_yes": 50,
        "total_survey_3_sometime": 30,
        "total_survey_3_no": 20,
        "total_survey_4_yes": 40,
        "total_survey_4_sometime": 25,
        "total_survey_4_no": 35,
        "total_survey_5_yes": 60,
        "total_survey_5_sometime": 10,
        "total_survey_5_no": 30,
        "total_survey_6_yes": 20,
        "total_survey_6_sometime": 60,
        "total_survey_6_no": 20,
        "total_survey_7_yes": 50,
        "total_survey_7_sometime": 20,
        "total_survey_7_no": 30,
        "total_survey_8_yes": 60,
        "total_survey_8_sometime": 20,
        "total_survey_8_no": 20,
        "total_survey_9_yes": 70,
        "total_survey_9_sometime": 20,
        "total_survey_9_no": 10,
        "total_survey_10_yes": 60,
        "total_survey_10_sometime": 20,
        "total_survey_10_no": 20,
        "total_survey_11_yes": 60,
        "total_survey_11_sometime": 20,
        "total_survey_11_no": 20,
        "total_survey_12_yes": 60,
        "total_survey_12_sometime": 20,
        "total_survey_12_no": 20,
        "total_survey_13_yes": 60,
        "total_survey_13_sometime": 20,
        "total_survey_13_no": 20,
        "total_survey_14_yes": 60,
        "total_survey_14_sometime": 20,
        "total_survey_14_no": 20,
        "total_survey_15_phone": 60,
        "total_survey_15_text": 20,
        "total_survey_15_email": 20,
        "total_survey_16_brief": 60,
        "total_survey_16_reasonable": 20,
        "total_survey_16_excessive": 20,
        "total_survey_17_morning": 50,
        "total_survey_17_afternoon": 20,
        "total_survey_17_evening": 20,
        "total_survey_17_weekend": 10,
        "total_survey_18_monday": 20,
        "total_survey_18_tuesday": 20,
        "total_survey_18_wednesday": 40,
        "total_survey_18_thursday": 15,
        "total_survey_18_friday": 5
      }
    }}
    return result;
    
    const response = await PAPI.post(
      `/form/patient_survey_form/data`,printFilter,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchDotPhysicalForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/dot_physical_forms?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSIngleDotPhysicalForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/dot_physical_forms/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchImmunizationForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    order_by,
  } = filter;

  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    return PAPI.get(
      `form/immunization_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const fetchSingleImmunizationForm = async (account_id, location_id, id) => {
  try {
    const response = await PAPI.get(
      `/form/immunization_form/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const fetchSingleCarePlanForm = async (account_id, location_id, id) => {
  try {
    const result = {data: {
      "mrn": "7563468071207360",
      "patient_name": "John Duo",
      "dob": "1984-03-14",
      "dos": "2024-02-16",
      "pyh": ["11","14"],
      "treatments_box1": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "relevant_box1": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "p_preferences": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "treatments": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "solution": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "he_li_asse": "1",
      "asse_un_medi": "1",
      "asse_medi_bar_adh": "1",
      "issues": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      "p_agree": "1",
      "p_signature": null,
      "p_signature_date": "2024-04-16",
      "pro_signature": null,
      "pro_signature_date": "2024-04-16"
    }};

    return result;
  } catch (error) {}
};

export const fetchCommunityAssessmentForm = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    dos,
    search_term,
    order_by,
  } = filter;

  try {
    let searchDos = dos ? `&dos=${dos}` : "";
    let searchParam = search_term ? `&search_term=${search_term}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

    const result = {data:{
      "count": 2,
      "per_page": 10,
      "page": 1,
      "total_pages": 1,
      "results": [
        {
          "id": 2,
          "account_id": 11,
          "location_id": 10,
          "dos": "2024-10-25",
          "question_id": 2,
          "answer": 2,
          "created_at": "2024-10-03T07:33:38.333307",
          "updated_at": "2024-10-03T07:33:38.333307",
        },
        {
          "id": 1,
          "account_id": 11,
          "location_id": 10,
          "dos": "2024-10-25",
          "question_id": 1,
          "answer": 1,
          "created_at": "2024-10-03T07:33:38.333307",
          "updated_at": "2024-10-03T07:33:38.333307",
        }
      ]
    }}
    return result;

    const response =  PAPI.get(
      `form/community_assessment_form?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchDos}${orderBy}${searchParam}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getCommunityPrintData = async (printFilter) => {
  try {
    const result = {data:{
      "results": [
        {
          "question": "TRANSPORTATION",
          "yes": 2,
          "no": 2
        },
        {
          "question": "CHILDCARE",
          "yes": 1,
          "no": 2
        },
        {
          "question": "ADULT CARE",
          "yes": 2,
          "no": 4
        },
        {
          "question": "COMMUNITY & RECREATION",
          "yes": 0,
          "no": 2
        },
        {
          "question": "EDUCATION",
          "yes": 2,
          "no": 0
        },
        {
          "question": "EMERGENCY SERVICES",
          "yes": 2,
          "no": 2
        },
        {
          "question": "EMPLOYMENT",
          "yes": 2,
          "no": 2
        },
        {
          "question": "FAMILY SERVICES",
          "yes": 5,
          "no": 2
        },
        {
          "question": "FINANCIAL LEGAL",
          "yes": 2,
          "no": 0
        },
        {
          "question": "MEDICAL RESOURCES",
          "yes": 4,
          "no": 2
        },
        {
          "question": "RESIDENTIAL",
          "yes": 3,
          "no": 2
        },
        {
          "question": "FOOD & NUTRITION SERVICES",
          "yes": 2,
          "no": 4
        },
        {
          "question": "MENTAL HEALTH SERVICES",
          "yes": 0,
          "no": 2
        },
        {
          "question": "DISABILITY SUPPORT",
          "yes": 2,
          "no": 3
        },
        {
          "question": "VETERAN SERVICES",
          "yes": 3,
          "no": 0
        },
        {
          "question": "CULTURAL RESOURCES",
          "yes": 0,
          "no": 0
        },
        {
          "question": "ADDICTION RECOVERY",
          "yes": 1,
          "no": 2
        },
        {
          "question": "IMMIGRANT SERVICES",
          "yes": 3,
          "no": 2
        },
        {
          "question": "HOMELESS SERVICES",
          "yes": 2,
          "no": 2
        },
        {
          "question": "ENVIRONMENTAL SERVICES",
          "yes": 9,
          "no": 2
        },
        {
          "question": "HOUSING ASSISTANCE",
          "yes": 2,
          "no": 4
        },
        {
          "question": "LITERACY PROGRAMS",
          "yes": 3,
          "no": 2
        },
        {
          "question": "DOMESTIC VIOLENCE SUPPORT",
          "yes": 2,
          "no": 2
        },
        {
          "question": "COMMUNITY GARDEN",
          "yes": 0,
          "no": 2
        },
        {
          "question": "SKILL TRAINING & DEVELOPMENT",
          "yes": 3,
          "no": 2
        },
      ]
    }}
    return result;

    const response = await PAPI.post(
      `/form/community_assessment_form/data`,printFilter,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};